import React from 'react'
import Footer from '../components/Footer'
import Banner from '../components/Banner'
import Reviews from '../components/Reviews';
import BlogCard from '../components/BlogCard';
import CTA from '../components/Cta';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { apiUrl } from '../../../utils/config';

const fetchProducts = async () => {
  const { data } = await axios.get(apiUrl+"/menuItem");
  return data.list;
};

const fetchBlogs = async () => {
  const { data } = await axios.get(apiUrl+"/blog");
  return (data.list || []).filter(b => b.status === "Published");
};

const CATEGORIES = ["All", "Breakfast", "Dinner", "Sides", "Snacks", "Desserts"];
const TESTIMONIALS = [
  { id: 1, name: "Priya Sharma", role: "Food Enthusiast", avatar: "PS", text: "The masala dosa here is absolutely authentic! Reminds me of my grandmother's cooking back in Chennai. Ordering every week now!", rating: 5 },
  { id: 2, name: "Rahul Mehta", role: "Working Professional", avatar: "RM", text: "Perfect for quick lunches. Biryani arrives hot and fresh. The packaging is eco-friendly too which I really appreciate.", rating: 5 },
  { id: 3, name: "Anita Krishnan", role: "Home Chef", avatar: "AK", text: "As someone who loves cooking, I'm picky about food quality. GamapaFoods never disappoints. Authentic recipes, fresh ingredients.", rating: 4 },
  { id: 4, name: "Vikram Nair", role: "Foodie & Blogger", avatar: "VN", text: "Reviewed hundreds of food delivery apps. GamapaFoods stands out for authenticity and speed. The gulab jamun is divine!", rating: 5 },
];


 
export default function HomePage() {
  const { data: products, isLoading: pLoading } = useQuery({ queryKey: ['products'], queryFn: fetchProducts });
  const { data: blogs } = useQuery({ queryKey: ['blogs'], queryFn: fetchBlogs });

  return (
   <>
   <Banner PRODUCTS={products} />
   <Reviews  TESTIMONIALS = {TESTIMONIALS} />
   <BlogCard  BLOGS = {blogs || []}  />
   <CTA />
   <Footer />
   </>
  )
}
